import React from 'react';
import LazyLoad from 'react-lazyload';
import { MetricsElement } from "react-metrics";

import { Carousel, setCarouselHeight } from '../../shared/components/carousel';
import NavArrow from '../../shared/components/nav-arrow';
import ImageWithPlaceholder from '../../shared/components/image-with-placeholder';

import '../css/content-carousel.less';

class ContentCarousel extends React.Component{

    state={
        selectedIndex: 0,
    }

    carousel = React.createRef();

    handleChange = (newIndex) => {
        this.setState({selectedIndex: newIndex});
    }

    renderControlButtons = () =>
        <ul className='control-buttons'>
        {
            this.props.list.map((element, i) => {
                return(
                    <MetricsElement key={`control-button-${i}`}>
                        <li
                            data-metrics-event-name="linkClick"
                            data-metrics-event="e_linkClick"
                            data-metrics-link-id={`pdp:rich-content:carousel:${element.name}:banner:${this.props.sku}`}
                            className={i === this.state.selectedIndex ? 'selected' : ''}
                            onClick={()=>this.handleChange(i)}
                        >
                            {element.name}
                        </li>
                    </MetricsElement>
                )
            })
        }
        </ul>

    renderArrowControl = (settings, hideNavControls, navArrowClasses, isMobile, Component, direction) => {
        if(isMobile && !hideNavControls)return null;
        //if first slide or last slide, render w/o metrics wrapper
        if(direction === 'prev' && settings.currentSlide === 0 ||
            direction === 'next' && settings.currentSlide === settings.slideCount - 1)return <Component {...settings} />;
        const index = direction === 'prev' ? settings.currentSlide - 1 : settings.currentSlide + 1;
        const element = this.props.list[index];
        return(
            <MetricsElement
                element='div'
                data-metrics-event-name="linkClick"
                data-metrics-event="e_linkClick"
                data-metrics-link-id={`pdp:rich-content:carousel:${element.name}:arrow:${this.props.sku}`}
            >
                <Component{...settings} className={navArrowClasses}/>
            </MetricsElement>
        )
    }

    controls = (isMobile, hideNavControls, navArrowClasses) => {
        return {
            renderCenterLeftControls : (settings) => this.renderArrowControl(settings, hideNavControls, navArrowClasses, isMobile, NavArrow.PrevArrow, 'prev'),
            renderCenterRightControls: (settings) => this.renderArrowControl(settings, hideNavControls, navArrowClasses, isMobile, NavArrow.NextArrow, 'next'),
            renderTopCenterControls: (isMobile || hideNavControls) ? () => null : this.renderControlButtons,
            renderBottomCenterControls: (isMobile && !hideNavControls) ? this.renderControlButtons : () => null,
            slideIndex: this.state.selectedIndex,
            afterSlide: (selectedIndex) => this.setState({ selectedIndex }),
            heightMode: 'max'
        }
    }

    render(){
        const { list=[], isMobile, hideNavControls=false, navArrowClasses } = this.props;
        const settings = {
            slidesToShow:1,
            slidesToScroll: 1,
            ...this.controls(isMobile, hideNavControls, navArrowClasses)
        }
        return(
            <LazyLoad once={true} offset={100}>
                <div className='clearfix'>{/*TEMP: add this incase float elements preceed this*/}</div>
                <div className='custom-component content-carousel'>
                    <Carousel ref={ this.carousel } {...settings}>
                    {
                        this.props.list.map((element, i)=>{
                            if(isMobile){
                                return(
                                    <MobileContentCarouselItem
                                        key={`mobile-content-carousel-item-${i}`}
                                        index={i}
                                        carousel={this.carousel}
                                        {...element}
                                    />
                                )
                            }else{
                                return(
                                    <ContentCarouselItem
                                        key={`content-carousel-item-${i}`}
                                        index={i}
                                        carousel={this.carousel}
                                        {...element}
                                    />
                                )
                            }
                        })
                    }
                    </Carousel>
                </div>
            </LazyLoad>
        )
    }
}

const ContentCarouselItem = ({ imageUrl='', description={}, index, carousel }) => {
    const { header, subHeader, text, classes='' } = description;
    const showText = !!(header || subHeader || text);
    return(
        <div className={`content-carousel-item${classes.length > 0 ? (' ' + classes) : ''}`}>
            <ImageWithPlaceholder
                src={imageUrl}
                onLoad={() => setCarouselHeight(carousel.current)}
            />
            {showText && <div className='item-text-box'>
                <h6>{header}</h6>
                <h1>{subHeader}</h1>
                <p>{text}</p>
            </div>}
        </div>
    )
}

const MobileContentCarouselItem = ({ mobileImageUrl, imageUrl='', description={}, index, carousel }) => {
    const { header, subHeader, text, classes='' } = description;
    return(
        <div className={`mobile-content-carousel-item${classes.length > 0 ? (' ' + classes) : ''}`}>
            <div className='item-text-box'>
                <h6>{header}</h6>
                <h1>{subHeader}</h1>
                <p>{text}</p>
            </div>
            <ImageWithPlaceholder
                src={mobileImageUrl ? mobileImageUrl : imageUrl}
                onLoad={() => setCarouselHeight(carousel.current)}
            />
        </div>
    )
}


export default ContentCarousel;
